import type { Locale } from '@et/schema';

export const LOCALES: readonly Locale[] = ['en', 'es', 'pt-PT'];
export const DEFAULT_LOCALE: Locale = 'en';

/** `pt` na URL, `pt-PT` no codigo: o utilizador nao escreve regiao. */
const URL_TO_LOCALE: Record<string, Locale> = { en: 'en', es: 'es', pt: 'pt-PT' };
const LOCALE_TO_URL: Record<Locale, string> = { en: 'en', es: 'es', 'pt-PT': 'pt' };

export const toUrlSegment = (locale: Locale): string => LOCALE_TO_URL[locale];
export const fromUrlSegment = (segment: string): Locale | null => URL_TO_LOCALE[segment] ?? null;

/**
 * Troca o prefixo de lingua **preservando o resto do caminho**.
 * E o que faz com que mudar de lingua nao perca a investigacao em curso.
 */
export function swapLocaleInPath(pathname: string, next: Locale): string {
  const segments = pathname.split('/');
  const first = segments[1] ?? '';
  if (fromUrlSegment(first) !== null) {
    segments[1] = toUrlSegment(next);
    return segments.join('/');
  }
  return `/${toUrlSegment(next)}${pathname === '/' ? '' : pathname}`;
}

/** Escolhe o locale a partir do Accept-Language do browser. */
export function detectLocale(preferred: readonly string[]): Locale {
  for (const tag of preferred) {
    const lower = tag.toLowerCase();
    if (lower.startsWith('pt')) return 'pt-PT';
    if (lower.startsWith('es')) return 'es';
    if (lower.startsWith('en')) return 'en';
  }
  return DEFAULT_LOCALE;
}

/**
 * Caminhos dentro da lingua actual.
 *
 * Relativos com `..` partem do segmento e nao da raiz da lingua: de
 * `/en/claim/x`, `..` da `/en/claim`, que nao e rota nenhuma. Construir a
 * partir do prefixo de lingua torna cada ligacao independente de onde foi
 * escrita, e e uma classe inteira de 404 que deixa de existir.
 */
export const localePath = (locale: Locale, ...segments: string[]): string =>
  `/${toUrlSegment(locale)}${segments.map((s) => `/${s}`).join('')}`;
